// Libraries
import axios from 'axios';
const api = process.env.REACT_APP_SERVER_ENDPOINT;

// PROFILE SERVICES
export default {
	/**
	 * Removes a user from a specific team
	 * Only available to Team Captains
	 * The captain cannot remove itself
	 *
	 * URL: /team/my/ {userId}
	 * Method: DELETE
	 * URL Params:
	 * Required: userId
	 * Success Response: 200
	 * Error Response: 401 Unauthorized - list of authentication servers
	 *
	 * @param {*} userId
	 * @returns
	 */
	removeUserFromTeam(userId) {
		return axios.delete(`${api}/team/my/${userId}`, {
			withCredentials: true,
		});
	},


	/**
   * @description Transfer a User to Another Team in the app
   * @date 2018-09-27
   * @param {*} transferCode
   * @returns
   */
  transferUserToAnotherTeam(transferCode) {
		return axios.put(`${api}/team/change/${transferCode}`, null, {
			withCredentials: true,
		});
	},
};



// WEBPACK FOOTER //
// ./src/data/services/team-services.js